// An empty reference that must be set. Required in some forms where the initial draft must already contain a value
// but the user needs to select it first.
import { InternalId } from '@edgebox/data-definition-kit';

export const NULL_ID = '000000000000000000000000' as InternalId;
